import { io } from 'socket.io-client';

export const socket = io({
  autoConnect: true,
  transports: ['polling', 'websocket'],
  upgrade: true,
  timeout: 15_000,
  reconnection: true,
  reconnectionAttempts: Infinity,
  reconnectionDelay: 500,
  reconnectionDelayMax: 4000,
  randomizationFactor: 0.4
});

function waitForConnection(timeoutMs = 8_000) {
  if (socket.connected) return Promise.resolve();
  return new Promise((resolve, reject) => {
    const timer = window.setTimeout(() => {
      socket.off('connect', onConnect);
      reject(new Error('Verbindung wird wiederhergestellt. Bitte erneut versuchen.'));
    }, timeoutMs);
    const onConnect = () => {
      window.clearTimeout(timer);
      resolve();
    };
    socket.once('connect', onConnect);
    if (!socket.active) socket.connect();
  });
}

export async function emitAck(event, payload = {}) {
  await waitForConnection();
  return new Promise((resolve, reject) => {
    socket.timeout(15_000).emit(event, payload, (error, response) => {
      if (error) {
        reject(new Error('Die Antwort ist ausgeblieben. Verbindung bleibt aktiv – bitte erneut versuchen.'));
        return;
      }
      if (!response?.ok) {
        reject(new Error(response?.error || 'Aktion fehlgeschlagen.'));
        return;
      }
      resolve(response.data);
    });
  });
}
